export default {
  "content": "<path fill=\"#FFF\" d=\"M11.61 1.065a.4.4 0 01.015.56L6.945 6.65c-.21.225-.505.35-.81.35a1.1 1.1 0 01-.805-.365L.855 1.645a.4.4 0 01.025-.56L1.36.64c.165-.15.42-.14.57.025L6.15 5.38 10.57.63c.15-.165.41-.17.57-.015z\"/>",
  "attrs": {
    "xmlns": "http://www.w3.org/2000/svg",
    "width": "12",
    "height": "7",
    "fill": "none"
  }
};